 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"forget-password":"forget-password","desktop_layout":"desktop_layout","desktop_home":"desktop_home","desktop_settings":"desktop_settings"}[chunkId]||chunkId) + "." + {"chunk-29d24a56":"ed217e38","chunk-2d0a2d89":"517b01dc","chunk-2d0a3381":"28f6f334","chunk-2d0a3841":"59f6ee0f","chunk-2d0a3c3b":"7c6640ed","chunk-2d0a3c79":"0beea593","chunk-2d0a3d18":"ab0efb2a","chunk-2d0a4385":"89ff6e5c","chunk-2d0a4780":"d28896da","chunk-2d0a47a1":"5c708a50","chunk-2d0a4fc9":"f98588e9","chunk-2d0aa55a":"4c5ca11b","chunk-2d0aa794":"c6330a20","chunk-2d0ab8f3":"e86e3a56","chunk-2d0abe0d":"9c44d9ae","chunk-2d0abf7d":"1ecbc8f4","chunk-2d0ac59d":"c0969bdb","chunk-2d0ae9c1":"45db6a1f","chunk-2d0aed59":"ab8b1e84","chunk-2d0b1be4":"3ee0e949","chunk-2d0b28b8":"63c6bac3","chunk-2d0b2ea9":"17c507a7","chunk-2d0b5f7c":"16ef6c7a","chunk-2d0b68b0":"d1b72dfe","chunk-2d0b8a73":"71da414e","chunk-2d0b93e8":"ad11bf3f","chunk-2d0b9d17":"9927c2d5","chunk-2d0ba0b9":"d267b20a","chunk-2d0ba165":"4a1541a8","chunk-2d0ba556":"71d76712","chunk-2d0bd56d":"fa6c9987","chunk-2d0bd7f5":"733e239a","chunk-2d0bd7f8":"88eaf0e7","chunk-2d0bd802":"33510078","chunk-2d0be16a":"0782e20e","chunk-2d0c0686":"3852b383","chunk-2d0c06b5":"e29ae13d","chunk-2d0c0c38":"b16fefa6","chunk-2d0c1415":"038c89ae","chunk-2d0c15aa":"42475fa5","chunk-2d0c19e3":"4acdc03c","chunk-2d0c1bb4":"3586fa99","chunk-2d0c4ff7":"adcb3186","chunk-2d0c5111":"1233c301","chunk-2d0c5b15":"90b2ee12","chunk-2d0c7731":"26691e26","chunk-2d0c7d22":"2f634c8b","chunk-2d0c8290":"65b64ecf","chunk-2d0c8da6":"829b1daf","chunk-2d0c9b3a":"d5987ae5","chunk-2d0cbe2a":"044035ab","chunk-2d0ce7b2":"716e2fd7","chunk-2d0ce82d":"78dbeb61","chunk-2d0ced85":"61ae00b9","chunk-2d0cff00":"0507a030","chunk-2d0d30e4":"e182de44","chunk-2d0d6b83":"22660572","chunk-2d0d7fea":"3a61e682","chunk-2d0d9fde":"dcd6c661","chunk-2d0daae1":"d2d6752f","chunk-2d0dd0d9":"c1134669","chunk-2d0de515":"2558b6af","chunk-2d0de6b6":"3be2ade3","chunk-2d0de6bb":"ff3f38b2","chunk-2d0de76c":"ecdaece3","chunk-2d0dee73":"f61c2302","chunk-2d0e1c1c":"e1a271e7","chunk-2d0e235f":"77b14bd4","chunk-2d0e2ce2":"fb78d914","chunk-2d0e611f":"6477f2e4","chunk-2d0e6c4a":"4ecc3d42","chunk-2d0e8881":"ad64579e","chunk-2d0e941b":"1c2b8cfc","chunk-2d0e944b":"ffdeeaba","chunk-2d0e9801":"9eaa896f","chunk-2d0efc73":"83af4f0b","chunk-2d0efd3e":"70996aa0","chunk-2d0f04be":"9e80c520","chunk-2d0f07df":"59ff159f","chunk-2d0f0861":"3b45267d","chunk-2d0f0b85":"6ff458de","chunk-2d0f0c42":"3dfdc884","chunk-2d0f0f03":"c9a68edd","chunk-2d0f1022":"408ead88","chunk-2d207b97":"77fddd1d","chunk-2d20ec31":"48995533","chunk-2d20f384":"92f2d61d","chunk-2d20f3a6":"9123f993","chunk-2d20f8e8":"229af04f","chunk-2d2101ec":"866b01b1","chunk-2d210a68":"35f6542f","chunk-2d213196":"42e70007","chunk-2d213737":"bb328113","chunk-2d213aeb":"a12d8157","chunk-2d2140aa":"9722752a","chunk-2d214400":"f08f1e73","chunk-2d2160ae":"4bf943ec","chunk-2d216870":"bd783b52","chunk-2d2172f8":"fc1cfb15","chunk-2d21af49":"31634fe5","chunk-2d21af77":"db0aa8c2","chunk-2d21af90":"3fdb7b6d","chunk-2d21b0aa":"159eab4a","chunk-2d21b13a":"1ac7ca05","chunk-2d21d4ff":"3aa3a724","chunk-2d21d6c2":"a061fb38","chunk-2d21d6de":"96c20a6c","chunk-2d21ee4e":"7615f03f","chunk-2d221f3b":"431a09e1","chunk-2d221f8a":"d5a26bf4","chunk-2d2226cc":"abb567fc","chunk-2d222d35":"d0354315","chunk-2d224c74":"ae5a0821","chunk-2d225be9":"d09ea3fb","chunk-2d228ffc":"ff9667a8","chunk-2d229396":"5232b55e","chunk-2d22b925":"21085300","chunk-2d22bd41":"c425bc50","chunk-2d22c123":"58745899","chunk-2d22c2b2":"b9826eb4","chunk-2d22c53c":"79063d1c","chunk-2d22d5e9":"ad03f511","chunk-2d22d93a":"2a02ac15","chunk-2d23010d":"12fdaa67","chunk-2d230668":"5e3846df","chunk-2d230e25":"3b381e16","chunk-2d230fb4":"318c0c4a","chunk-2d237751":"1683afd0","chunk-2d237b31":"f964aa2e","chunk-2d237ca6":"108e564b","chunk-2d2384d0":"b16827e8","chunk-47c57078":"60f7402d","chunk-129eb870":"b21fe510","chunk-2d0e451d":"f5d62fdc","forget-password":"c478f015","chunk-4c5744d4":"032c1005","chunk-58680214":"92496c22","chunk-661b7c59":"bafd3b0c","chunk-231f71f6":"5e94fff1","desktop_layout":"fb7bf07f","chunk-72498097":"c7af5ce7","chunk-74c3ef7d":"19eaf5fa","chunk-7b9d50cc":"0ae92118","desktop_home":"ffa46d58","desktop_settings":"d3c86a60"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-47c57078":1,"chunk-129eb870":1,"forget-password":1,"chunk-58680214":1,"chunk-661b7c59":1,"chunk-231f71f6":1,"desktop_layout":1,"desktop_home":1,"desktop_settings":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"forget-password":"forget-password","desktop_layout":"desktop_layout","desktop_home":"desktop_home","desktop_settings":"desktop_settings"}[chunkId]||chunkId) + "." + {"chunk-29d24a56":"31d6cfe0","chunk-2d0a2d89":"31d6cfe0","chunk-2d0a3381":"31d6cfe0","chunk-2d0a3841":"31d6cfe0","chunk-2d0a3c3b":"31d6cfe0","chunk-2d0a3c79":"31d6cfe0","chunk-2d0a3d18":"31d6cfe0","chunk-2d0a4385":"31d6cfe0","chunk-2d0a4780":"31d6cfe0","chunk-2d0a47a1":"31d6cfe0","chunk-2d0a4fc9":"31d6cfe0","chunk-2d0aa55a":"31d6cfe0","chunk-2d0aa794":"31d6cfe0","chunk-2d0ab8f3":"31d6cfe0","chunk-2d0abe0d":"31d6cfe0","chunk-2d0abf7d":"31d6cfe0","chunk-2d0ac59d":"31d6cfe0","chunk-2d0ae9c1":"31d6cfe0","chunk-2d0aed59":"31d6cfe0","chunk-2d0b1be4":"31d6cfe0","chunk-2d0b28b8":"31d6cfe0","chunk-2d0b2ea9":"31d6cfe0","chunk-2d0b5f7c":"31d6cfe0","chunk-2d0b68b0":"31d6cfe0","chunk-2d0b8a73":"31d6cfe0","chunk-2d0b93e8":"31d6cfe0","chunk-2d0b9d17":"31d6cfe0","chunk-2d0ba0b9":"31d6cfe0","chunk-2d0ba165":"31d6cfe0","chunk-2d0ba556":"31d6cfe0","chunk-2d0bd56d":"31d6cfe0","chunk-2d0bd7f5":"31d6cfe0","chunk-2d0bd7f8":"31d6cfe0","chunk-2d0bd802":"31d6cfe0","chunk-2d0be16a":"31d6cfe0","chunk-2d0c0686":"31d6cfe0","chunk-2d0c06b5":"31d6cfe0","chunk-2d0c0c38":"31d6cfe0","chunk-2d0c1415":"31d6cfe0","chunk-2d0c15aa":"31d6cfe0","chunk-2d0c19e3":"31d6cfe0","chunk-2d0c1bb4":"31d6cfe0","chunk-2d0c4ff7":"31d6cfe0","chunk-2d0c5111":"31d6cfe0","chunk-2d0c5b15":"31d6cfe0","chunk-2d0c7731":"31d6cfe0","chunk-2d0c7d22":"31d6cfe0","chunk-2d0c8290":"31d6cfe0","chunk-2d0c8da6":"31d6cfe0","chunk-2d0c9b3a":"31d6cfe0","chunk-2d0cbe2a":"31d6cfe0","chunk-2d0ce7b2":"31d6cfe0","chunk-2d0ce82d":"31d6cfe0","chunk-2d0ced85":"31d6cfe0","chunk-2d0cff00":"31d6cfe0","chunk-2d0d30e4":"31d6cfe0","chunk-2d0d6b83":"31d6cfe0","chunk-2d0d7fea":"31d6cfe0","chunk-2d0d9fde":"31d6cfe0","chunk-2d0daae1":"31d6cfe0","chunk-2d0dd0d9":"31d6cfe0","chunk-2d0de515":"31d6cfe0","chunk-2d0de6b6":"31d6cfe0","chunk-2d0de6bb":"31d6cfe0","chunk-2d0de76c":"31d6cfe0","chunk-2d0dee73":"31d6cfe0","chunk-2d0e1c1c":"31d6cfe0","chunk-2d0e235f":"31d6cfe0","chunk-2d0e2ce2":"31d6cfe0","chunk-2d0e611f":"31d6cfe0","chunk-2d0e6c4a":"31d6cfe0","chunk-2d0e8881":"31d6cfe0","chunk-2d0e941b":"31d6cfe0","chunk-2d0e944b":"31d6cfe0","chunk-2d0e9801":"31d6cfe0","chunk-2d0efc73":"31d6cfe0","chunk-2d0efd3e":"31d6cfe0","chunk-2d0f04be":"31d6cfe0","chunk-2d0f07df":"31d6cfe0","chunk-2d0f0861":"31d6cfe0","chunk-2d0f0b85":"31d6cfe0","chunk-2d0f0c42":"31d6cfe0","chunk-2d0f0f03":"31d6cfe0","chunk-2d0f1022":"31d6cfe0","chunk-2d207b97":"31d6cfe0","chunk-2d20ec31":"31d6cfe0","chunk-2d20f384":"31d6cfe0","chunk-2d20f3a6":"31d6cfe0","chunk-2d20f8e8":"31d6cfe0","chunk-2d2101ec":"31d6cfe0","chunk-2d210a68":"31d6cfe0","chunk-2d213196":"31d6cfe0","chunk-2d213737":"31d6cfe0","chunk-2d213aeb":"31d6cfe0","chunk-2d2140aa":"31d6cfe0","chunk-2d214400":"31d6cfe0","chunk-2d2160ae":"31d6cfe0","chunk-2d216870":"31d6cfe0","chunk-2d2172f8":"31d6cfe0","chunk-2d21af49":"31d6cfe0","chunk-2d21af77":"31d6cfe0","chunk-2d21af90":"31d6cfe0","chunk-2d21b0aa":"31d6cfe0","chunk-2d21b13a":"31d6cfe0","chunk-2d21d4ff":"31d6cfe0","chunk-2d21d6c2":"31d6cfe0","chunk-2d21d6de":"31d6cfe0","chunk-2d21ee4e":"31d6cfe0","chunk-2d221f3b":"31d6cfe0","chunk-2d221f8a":"31d6cfe0","chunk-2d2226cc":"31d6cfe0","chunk-2d222d35":"31d6cfe0","chunk-2d224c74":"31d6cfe0","chunk-2d225be9":"31d6cfe0","chunk-2d228ffc":"31d6cfe0","chunk-2d229396":"31d6cfe0","chunk-2d22b925":"31d6cfe0","chunk-2d22bd41":"31d6cfe0","chunk-2d22c123":"31d6cfe0","chunk-2d22c2b2":"31d6cfe0","chunk-2d22c53c":"31d6cfe0","chunk-2d22d5e9":"31d6cfe0","chunk-2d22d93a":"31d6cfe0","chunk-2d23010d":"31d6cfe0","chunk-2d230668":"31d6cfe0","chunk-2d230e25":"31d6cfe0","chunk-2d230fb4":"31d6cfe0","chunk-2d237751":"31d6cfe0","chunk-2d237b31":"31d6cfe0","chunk-2d237ca6":"31d6cfe0","chunk-2d2384d0":"31d6cfe0","chunk-47c57078":"fe2d8f1f","chunk-129eb870":"874463f3","chunk-2d0e451d":"31d6cfe0","forget-password":"7b921a26","chunk-4c5744d4":"31d6cfe0","chunk-58680214":"ca8ba22f","chunk-661b7c59":"b84806f0","chunk-231f71f6":"bae77959","desktop_layout":"e02c39a4","chunk-72498097":"31d6cfe0","chunk-74c3ef7d":"31d6cfe0","chunk-7b9d50cc":"31d6cfe0","desktop_home":"51ae4173","desktop_settings":"9388ef7e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.klook.com/s/dist_web/klook-open-platform-web/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
